import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Viewable } from '../../../../models/protocols/viewable';
import { BaseComponent } from '../../../../models/base/base-component';
import { SidebarNavViewModel } from './sidebar-nav-view-model';

@Component({
  selector: 'app-sidebar-navigation',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.scss'],
  providers: [SidebarNavViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SidebarNavComponent extends BaseComponent implements OnInit, Viewable {
  constructor(public viewModel: SidebarNavViewModel) {
    super();
  }

  @Output() collapsed = new EventEmitter<boolean>(true);

  // Not in the constructor: the parent's (collapsed) listener isn't attached yet, so a reload on a collapsed route
  // emitted true into nothing and the dashboard kept the expanded toast margin.
  override setupViews(): void {
    this.outputCollapsedSignal();
  }

  protected outputCollapsedSignal(): void {
    this.viewModel.collapsed$.subscribeWhileAlive({
      owner: this,
      next: collapsed => this.collapsed.emit(collapsed)
    });
  }
}
